import React from 'react';
import { Accordion } from './Accordion';
import { CheckCircle2, Gift } from 'lucide-react';
const bonos = [{
  icon: '🎮',
  title: 'BONO 1 — BANCO DE 50 JUEGOS RÍTMICOS RESUELTOS',
  value: '$12.000',
  bullets: ['50 juegos didácticos con y sin aparatos para hacer las clases divertidas y pedagógicas', 'Clasificados por edad, objetivo y aparato para encontrar el juego ideal en segundos', 'Descripción clara de cómo explicar cada juego a las alumnas', 'Variantes por nivel de dificultad: para grupos de iniciación y grupos avanzados', 'Formato visual e imprimible para tener a mano en cada clase', 'Juegos que desarrollan coordinación, ritmo, expresión y trabajo en equipo', 'Ideal para clases de 4 a 12 años sin importar el nivel del grupo']
}, {
  icon: '📅',
  title: 'BONO 2 — CALENDARIO DE TEMPORADA RESUELTO',
  value: '$10.000',
  bullets: ['Planificación semana a semana de marzo a diciembre con objetivos claros', 'Distribución de aparatos, técnica corporal y coreografía a lo largo del año', 'Momentos clave marcados: inicio, mitad y cierre de temporada', 'Espacio para exhibiciones, competencias y clases especiales', 'Formato editable para adaptar a tu propia agenda y contexto', 'Nunca más empezar el año sin saber qué vas a enseñar en cada etapa']
}, {
  icon: '📊',
  title: 'BONO 3 — FICHAS DE EVALUACIÓN Y SEGUIMIENTO DE ALUMNAS',
  value: '$9.000',
  bullets: ['40 páginas de fichas editables para registrar el progreso de cada alumna', 'Evaluación por aparato, técnica corporal y expresión artística', 'Seguimiento trimestral con indicadores claros de mejora', 'Fichas de evaluación inicial, intermedia y final de temporada', 'Formato profesional para compartir con padres y directivos', 'Herramienta clave para justificar tus tarifas y demostrar resultados reales']
}, {
  icon: '🎵',
  title: 'BONO 4 — GUÍA DE MÚSICA PARA GIMNASIA RÍTMICA INFANTIL',
  value: '$9.000',
  bullets: ['Selección musical organizada por edad, tempo, aparato y nivel', 'Cómo elegir la música correcta para cada tipo de clase y alumna', 'Criterios para estructurar una coreografía sobre una pieza musical', 'Géneros y estilos recomendados para rítmica infantil moderna', 'Errores más comunes al elegir música para clases de niñas pequeñas', 'Recomendaciones de plataformas y recursos para encontrar música libre de derechos']
}, {
  icon: '📩',
  title: 'BONO 5 — KIT DE COMUNICACIÓN PARA PADRES',
  value: '$10.000',
  bullets: ['Circulares de inicio de temporada listas para enviar', 'Autorizaciones, reglamentos internos y normas de la academia', 'Informe trimestral de progreso para entregar a cada familia', 'Modelos de mensajes de WhatsApp para comunicados frecuentes', 'Guía para manejar situaciones difíciles con padres exigentes', 'Todo listo para copiar, pegar y personalizar con tus datos']
}, {
  icon: '🥗',
  title: 'BONO 6 — MINI GUÍA DE NUTRICIÓN PARA NIÑAS DEPORTISTAS',
  value: '$8.000',
  bullets: ['Principios básicos de alimentación para niñas que practican gimnasia rítmica', 'Qué comer antes y después del entrenamiento según la edad', 'Hidratación durante la clase: recomendaciones prácticas para instructoras', 'Alimentos que favorecen la energía, la concentración y la recuperación', 'Señales de alerta nutricional que la instructora puede detectar en clase', 'Recurso complementario para compartir con padres y tutores']
}];
export function Bonos() {
  return <section className="py-10 md:py-20 bg-secondary-dark text-white" id="bonos" data-id="element-23">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-24">
        <div className="text-center mb-6 md:mb-12" data-id="element-25">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-primary rounded-full mb-4 md:mb-6 shadow-lg" data-id="element-26">
            <Gift className="w-6 h-6 md:w-8 md:h-8 text-white" data-id="element-27" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold font-serif mb-2 md:mb-4" data-id="element-28">
            Más los 6 Bonos Estratégicos
          </h2>
          <p className="text-base md:text-xl text-secondary-light" data-id="element-29">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="space-y-2.5 md:space-y-4 mb-6 md:mb-12" data-id="element-30">
          {bonos.map((bono, index) => <Accordion key={index} title={<div className="flex flex-col md:flex-row md:items-center gap-1.5 md:gap-4" data-id="element-32">
                  <div className="flex items-center gap-2 md:gap-3" data-id="element-33">
                    <span className="text-2xl md:text-3xl" data-id="element-34">{bono.icon}</span>
                    <h3 className="text-sm md:text-xl font-bold text-gray-900 leading-tight" data-id="element-35">
                      {bono.title}
                    </h3>
                  </div>
                  <div className="md:ml-auto flex items-center gap-1.5 md:gap-2 bg-accent px-2 py-0.5 md:px-3 md:py-1 rounded-full w-fit mt-1 md:mt-0" data-id="element-36">
                    <span className="text-gray-500 line-through text-xs md:text-sm" data-id="element-37">
                      Valor: {bono.value}
                    </span>
                    <span className="text-primary font-bold text-xs md:text-base" data-id="element-38">
                      → GRATIS
                    </span>
                  </div>
                </div>} className="border-none shadow-lg" data-id="element-31">
              <ul className="space-y-2 md:space-y-3 mt-3 md:mt-4" data-id="element-39">
                {bono.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-40">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-41" />
                    <span className="text-sm md:text-base text-gray-700 font-medium" data-id="element-42">
                      {bullet}
                    </span>
                  </li>)}
              </ul>
            </Accordion>)}
        </div>

        <div className="bg-white/10 border border-white/20 rounded-2xl p-5 md:p-8 text-center backdrop-blur-sm" data-id="element-43">
          <p className="text-base md:text-xl text-secondary-light mb-1 md:mb-2" data-id="element-44">
            Valor total de los 6 bonos:{' '}
            <span className="line-through opacity-70" data-id="element-45">$58.000</span>
          </p>
          <p className="text-2xl md:text-4xl font-bold text-white flex items-center justify-center gap-2 md:gap-3" data-id="element-46">
            <Gift className="w-6 h-6 md:w-8 md:h-8 text-primary" data-id="element-47" />
            <span className="text-primary" data-id="element-48">GRATIS</span> — Incluidos siempre
          </p>
        </div>
      </div>
    </section>;
}